export default "__VITE_ASSET__BeG$x1Cx__";